
import React, { Component } from 'react';
import { FormGroup, Label, FormFeedback, Input } from 'reactstrap';

var stateManager = require('../../utils/state/stateManager.js');
var screenKeyboardAction = require('../../utils/state/actions/views/onScreenKeyboard/screenKeyboardAction');
var ScreenKeyboardPayload = require('../../utils/state/actions/views/onScreenKeyboard/screenKeyboardPayload');
var terminalUtility = require('../../utils/domain/terminalUtility.js');
var displaySettingsUtils = require('../../utils/domain/settings/displaySettingsUtils');
const stringUtil = require("../../utils/string/stringUtil.js");

class InputTextComponent extends Component
{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.value = stringUtil.isStringNullOrEmpty(this.props.value) ? "" : String(this.props.value);
        this.getOnFocusHandler = this.getOnFocusHandler.bind(this);
        this.getInputMode = this.getInputMode.bind(this);
        this.raiseOnValueChangeEvent = this.raiseOnValueChangeEvent.bind(this);
    }

    componentDidUpdate()
    {
        const value = stringUtil.isStringNullOrEmpty(this.props.value) ? "" : String(this.props.value);
        if (value !== this.state.value) 
        {
            this.setState({ value });
        }
    }    

    componentWillUnmount()
    {
        stateManager.getStore().dispatch(screenKeyboardAction.createAction(null));
    }
    
    render()
    {
        const {containerStyle, ...restForInput} = this.props;
        return (
            <FormGroup floating className='form-input-group' {...containerStyle && {style: containerStyle}} >
                <Input
                    {...restForInput}
                    invalid={this.props.error ? true : false}
                    inputMode={this.getInputMode()}
                    innerRef={this.props.internalRef}
                    onFocus={this.getOnFocusHandler}
                    onKeyDown={(e) =>
                    {
                        e.stopPropagation();
                    }}
                    onChange={(e) =>
                    {
                        e.stopPropagation();

                        if (e == null || e.target == null)
                            return;
                        this.state.value = e.target.value;
                        this.raiseOnValueChangeEvent();
                    }}
                />
                <Label for={this.props.id}>{this.props.placeholder}{this.props.required ? <span className='text-danger'>*</span> : ''}</Label>
                <FormFeedback>{this.props.error}</FormFeedback>
            </FormGroup>
        )
    }



    getOnFocusHandler()
    {

        if (!terminalUtility.isRunningUnderWindowsShell() || !displaySettingsUtils.getDisplayOnScreenKeyboard())
            return null;

        let payload = new ScreenKeyboardPayload();
        payload.keyboardType = this.props.inputTextType;

        payload.onKeyDown = (key) =>
        {
            this.state.value = `${this.state.value}${key}`;
            this.raiseOnValueChangeEvent();
        }

        if (this.props.isMultiLine)
        {
            payload.onEnter = () =>
            {
                this.state.value = `${this.state.value}\n`;
                this.raiseOnValueChangeEvent();
            }
        }

        payload.onBackspace = (key) =>
        {
            if (this.state.value == "")
                return;

            this.state.value = this.state.value.substring(0, this.state.value.length - 1);
            this.raiseOnValueChangeEvent();
        }

        stateManager.getStore().dispatch(screenKeyboardAction.createAction(payload));
    }

    getInputMode()
    {
        if (!terminalUtility.isRunningUnderAndroidShell() && !terminalUtility.isRunningUnderIOSShell())
            return null;

        return this.props.inputTextType;
    }

    raiseOnValueChangeEvent()
    {
        if (this.props.onValueChange == null)
            return;

        this.props.onValueChange(this.state.value, this.props.name);
        this.setState({});
    }
}

export default InputTextComponent